import React, {useCallback, useEffect, memo, useMemo, useRef} from 'react'
import {
    DislikeOutlined,
    DislikeTwoTone,
    LikeOutlined,
    LikeTwoTone,
    CopyOutlined,
    AudioOutlined,
    FileSearchOutlined,
    AudioTwoTone,
    PauseCircleTwoTone,
} from '@ant-design/icons';
import './feedbacks.scss';
  
import {Space, message, Tooltip, Popover, Drawer  } from 'antd';
import {updateHistoryFeedback} from '../../requests';

const getPage = (str)=>{
    if(!str){
        return str;
    }
    let result = null;
    try{
        result = str.split('#').pop();
        return result;
    }catch(err){
        return result;
    }
}

const combinePrompts = (prompt1, prompt2, prompt3,prompt_id1,prompt_id2,prompt_id3,prompt_url1,prompt_url2,prompt_url3, prompt_number)=>{
    if(prompt_number === 0){
        return (
            <p>
                No relevant information found in files you uploaded, reply provided by chatGPT itself
            </p>
        );
    }
    return <div>
        {getPage(prompt_id1) !== null ? 
            <><a href={`${prompt_url1}#page=${getPage(prompt_id1)}`} target='_blank'>
                <h6>{prompt_id1}</h6>
            </a>
            <p>{prompt1}</p></> : <></>
        }
        {getPage(prompt_id2) !== null ? 
        <><a href={`${prompt_url2}#page=${getPage(prompt_id2)}`} target='_blank'>
            <h6>{prompt_id2}</h6>
        </a>
        <p>{prompt2}</p></> : <></>
        }

        {getPage(prompt_id3) !== null ? 
        <><a href={`${prompt_url3}#page=${getPage(prompt_id3)}`} target='_blank'>
            <h6>{prompt_id3}</h6>
        </a>
        <p>{prompt3}</p></> : <></>
        }
    </div>
  }

function Interaction  ({updateFeedback,id,feedback,content, prompt1, prompt2, prompt3, prompt_id1,prompt_id2,prompt_id3, setOpen, setContent, prompt_url1,prompt_url2,prompt_url3, prompt_number}){

    useEffect(()=>{


    },[])
    
    const HandleCopyClick=useCallback(()=>{
        try{
            navigator.clipboard.writeText(content);
            message.success('copied!')
        }catch(e){
            message.error('No access to clipboard')
        }
    },[])

    const HandleSourceClick=useCallback(()=>{
        // message.info('We are in the process of developing this function.')
        setContent(combinePrompts(prompt1,prompt2,prompt3,prompt_id1,prompt_id2,prompt_id3,prompt_url1,prompt_url2,prompt_url3, prompt_number));
        setOpen(true);
    },[])

    const HandleLikeClick=async()=>{
        try{
            const updatedValue = feedback !== 0 ? 0 : 1;
            await updateHistoryFeedback(id, updatedValue);
            updateFeedback(id,updatedValue);
            message.success('Receive feedback!');
        }catch(e){
            message.error('Update feedback failed!');
        }
    }

    const HandleDislikeClick=async()=>{
        try{
            const updatedValue = feedback !== 0 ? 0 : -1;
            await updateHistoryFeedback(id, updatedValue);
            updateFeedback(id,updatedValue);
            message.success('Receive feedback!');
        }catch(e){
            message.error('Update feedback failed!');
        }
    }


    const feedbackComp = ()=>{
        switch(feedback){
            case 0:
                return (
                    <Space>
                        <LikeOutlined onClick={HandleLikeClick} className='icon-size-small'/>
                        <DislikeOutlined onClick={HandleDislikeClick} className='icon-size-small'/>
                    </Space>
                );
            case 1:
                return <LikeTwoTone onClick={HandleLikeClick} className='icon-size-small'/>
            case -1:
                return <DislikeTwoTone onClick={HandleDislikeClick} className='icon-size-small'/>
            default:
                return (
                    <Space>
                        <LikeOutlined onClick={HandleLikeClick} className='icon-size-small'/>
                        <DislikeOutlined onClick={HandleDislikeClick} className='icon-size-small'/>
                    </Space>
                );
        }
    }
    
    return (
        <Space className='align-items-start chathistory-chat-feedback'>
            <Tooltip title="Copy to Clipboard">
                <CopyOutlined onClick={HandleCopyClick} className='icon-size-small'/>
            </Tooltip>
            <Tooltip title="Open source of response">
                <FileSearchOutlined onClick={HandleSourceClick} className='icon-size-small'/>
            </Tooltip>
            {feedbackComp()}
        </Space>
    )
}

export default (Interaction)